import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InvoiceNumberPipe } from './invoice-number.pipe';
import { CurrencyFormatPipe } from './currency-format.pipe';
import { ValidationMessagePipe } from './validation-message.pipe';
import { PriceUnitPipe } from './price-unit.pipe';
import { BreadcrumbTranslatePipe } from './breadcrumb-translate.pipe';

@NgModule({
	imports: [
		CommonModule
	],
	exports: [
		InvoiceNumberPipe,
		CurrencyFormatPipe,
		ValidationMessagePipe,
		PriceUnitPipe,
		BreadcrumbTranslatePipe
	],
	declarations: [
		InvoiceNumberPipe,
		CurrencyFormatPipe,
		ValidationMessagePipe,
		PriceUnitPipe,
		BreadcrumbTranslatePipe
	]
})

export class CustomPipesModule
{
}



// WEBPACK FOOTER //
// ./src/app/pipes/custom-pipes.module.ts